<script lang="ts">
  import { browser } from '$app/environment';

  import { createEventDispatcher } from 'svelte';

  export let videoControls = false;
  export let src: string;
  export let type: string | null | undefined = undefined;
  export let captionsSrc: string | undefined = undefined;

  const dispatch = createEventDispatcher<{ onLoad: void }>();

  let videoElement: HTMLVideoElement | null = null;
  let aspectRatio = '16/9';
  let controlsTimeout: ReturnType<typeof setTimeout> | null = null;

  function handleMouseEnter() {
    videoControls = true;
  }

  function handleMouseLeave() {
    videoControls = false;
  }

  function handleTouchStart() {
    videoControls = true;

    if (controlsTimeout) {
      clearTimeout(controlsTimeout);
    }
    controlsTimeout = setTimeout(() => {
      videoControls = false;
    }, 3000);
  }

  function handleLoaded() {
    if (videoElement) {
      aspectRatio = `${videoElement.videoWidth}/${videoElement.videoHeight}`;
    }

    dispatch('onLoad');
  }

  $: if (browser && videoElement && videoElement.readyState >= 1) {
    aspectRatio = `${videoElement?.videoWidth}/${videoElement?.videoHeight}`;
  }
</script>

<div class="video-wrapper max-h-[70vh]" style="aspect-ratio: {aspectRatio}">
  <video
    class="h-full w-full"
    loop
    controls="{videoControls}"
    preload="metadata"
    muted
    playsinline
    autoplay
    bind:this="{videoElement}"
    on:loadedmetadata="{handleLoaded}"
    on:loadeddata="{handleLoaded}"
    on:canplaythrough="{handleLoaded}"
    on:mouseenter="{handleMouseEnter}"
    on:mouseleave="{handleMouseLeave}"
    on:touchstart="{handleTouchStart}"
  >
    <source {src} {type} />

    {#if captionsSrc}
      <track default kind="captions" src="{captionsSrc}" />
    {/if}
  </video>
</div>

<style>
  .video-wrapper {
    position: relative;
    width: 100%;
  }
  .video-wrapper video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
